var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQueue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 50,
    viewBox: "0 0 49 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4536_11854",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 41,
    height: 42
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.832 4.16675H16.332C14.0862 4.16675 12.2487 6.04175 12.2487 8.33342V33.3334C12.2487 35.6251 14.0862 37.5001 16.332 37.5001H40.832C43.0779 37.5001 44.9154 35.6251 44.9154 33.3334V8.33342C44.9154 6.04175 43.0779 4.16675 40.832 4.16675ZM6.1237 12.5001C5.00078 12.5001 4.08203 13.4376 4.08203 14.5834V41.6668C4.08203 43.9584 5.91953 45.8334 8.16536 45.8334H34.707C35.8299 45.8334 36.7487 44.8959 36.7487 43.7501C36.7487 42.6043 35.8299 41.6668 34.707 41.6668H10.207C9.08411 41.6668 8.16536 40.7293 8.16536 39.5834V14.5834C8.16536 13.4376 7.24661 12.5001 6.1237 12.5001ZM30.6237 22.9167H36.7487C37.8716 22.9167 38.7904 21.9792 38.7904 20.8334C38.7904 19.6876 37.8716 18.7501 36.7487 18.7501H30.6237V12.5001C30.6237 11.3542 29.7049 10.4167 28.582 10.4167C27.4591 10.4167 26.5404 11.3542 26.5404 12.5001V18.7501H20.4154C19.2924 18.7501 18.3737 19.6876 18.3737 20.8334C18.3737 21.9792 19.2924 22.9167 20.4154 22.9167H26.5404V29.1667C26.5404 30.3126 27.4591 31.2501 28.582 31.2501C29.7049 31.2501 30.6237 30.3126 30.6237 29.1667V22.9167Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4536_11854)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 50,
    fill: "#A6B0CF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQueue);
export default __webpack_public_path__ + "static/media/queue.6aa4177e.svg";
export { ForwardRef as ReactComponent };